// TODO: Set correct values
// How many companies each user can create
import { countries } from '@topcon/topcon-utils';

// Cache expiration time for queries returning iconURL (in minutes)
// Icon URLs are presigned and expire, so we need to refetch periodically
export const ICON_URL_STALE_TIME_MINUTES = 10;
export const ICON_URL_STALE_TIME = ICON_URL_STALE_TIME_MINUTES * 60 * 1000;

export const COMPANIES_CREATED_LIMIT = 20;
// How many divisions each user can create
export const DIVISIONS_CREATED_LIMIT = 10;
// How many domains each company / division can have
export const DOMAINS_LIMIT = 5;
// How many identity providers each company / division can have
export const IDENTITY_PROVIDERS_LIMIT = 5;
// Default country
export const DEFAULT_COUNTRY = countries.getCountry('US')!;
